import { useState } from 'react';
import useApi from '../../api';
import { toast } from 'react-toastify';
import { NxtbnDrawer } from '../../components';
// import ReceiveInventory from './receiveInventory';
// import PurchaseEdit from './PurchaseEdit';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import StackTransferForm from './stockTransferForm';
import ReceiveTransfer from './receiveTransfer';

const GET_STOCK_TRANSFER_DETAILS = gql`
  query GetStockTransferDetails($id: ID!) {
    stockTransfer(id: $id) {
      dbId
      status
      toWarehouse {
        name
        location
      }
      fromWarehouse {
        name
        location
      }
      items {
        edges {
          node {
            dbId
            id
            quantity
            receivedQuantity
            rejectedQuantity
            variant {
              name
            }
          }
        }
      }
    }
  }
`;



interface StockDetailsViewProps{
    instance: any;
    isOpen: boolean;
    onClose: ()=>void;
    refresh: ()=>void;
}

function StockTransferDetailsView({instance, isOpen, onClose, refresh}:StockDetailsViewProps) {
    const [openEdit, setOpenEdit] = useState(false);
    const [openReceiveInventory, setOpenReceiveInventory] = useState(false);

    const api = useApi()


    const { data, loading, error, refetch } = useQuery(GET_STOCK_TRANSFER_DETAILS, {
        variables: { id: instance },
        notifyOnNetworkStatusChange: true,
      });

  

    const markAsTransit = () =>  {
        api.markAsTransitStockTransfer(instance).then((response) => {

        }, (error) => {
            toast.error('Error marking stock transfer in transit.')
        })
    }

    const deleteStockTransfer = () => {
        api.deleteStockTransfer(instance).then((response) => {
            toast.success('Purchase deleted successfully.')
            refresh()
            onClose()
        }, (error) => {
            toast.error('Error deleting purchase.')
        })
    }

    const markAsCompleted = () => {
        api.markAsCompletedStockTransfer(instance).then((response) => {
            toast.success('Purchase marked as received successfully.')
            refresh()
            onClose()
        }, (error) => {
            if (error.response.data && Array.isArray(error.response.data)) {
                return toast.error(error.response.data[0])

            } else {
                toast.error('Error marking stock transfer as received.')
            }
        })
    }
    
  return (
    <NxtbnDrawer isOpen={isOpen} onClose={onClose} title='Stock Transfer Detail'>
        {data?.stockTransfer?.status === 'PENDING' && (
            <div className="flex gap-2 mb-4">
                <button onClick={() => setOpenEdit(true)} className="bg-blue-500 text-white py-2 px-4 rounded">
                    Edit
                </button>
                <button onClick={markAsTransit} className="bg-gray-500 text-white py-2 px-4 rounded">
                    Mark as In-Transit
                </button>
                <button onClick={deleteStockTransfer} className="bg-red-500 text-white py-2 px-4 rounded">
                    Delete
                </button>
            </div>
        )}
        {data?.stockTransfer?.status === 'IN_TRANSIT' && (
           <>
             <div className="mb-4">
                <button onClick={() => setOpenReceiveInventory(true)}  className="bg-blue-500 text-white py-2 px-4 rounded">
                    Receive Inventory
                </button>
            </div>
            <div>
                <button onClick={markAsCompleted} className="bg-gray-500 text-white py-2 px-4 rounded">
                    Mark as Received
                </button>
            </div>
           </>
        )}

        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>Purchase Info</h3>
            <div>
                <div><strong>Purchase ID: </strong>{data?.stockTransfer?.dbId}</div>
                <div><strong>Purchase status: </strong>{data?.stockTransfer?.status}</div>
            </div>
        </div>

        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>From Warehosue</h3>
            <div>
                <div><strong>Name: </strong>{data?.stockTransfer?.fromWarehouse?.name}</div>
                <div><strong>Location: </strong>{data?.toWarehouse?.fromWarehouse?.location}</div>
            </div>
        </div>

        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>To Warehosue</h3>
            <div>
                <div><strong>Name: </strong>{data?.stockTransfer?.toWarehouse?.name}</div>
                <div><strong>Location: </strong>{data?.stockTransfer?.toWarehouse?.location}</div>
            </div>
        </div>


        <div className="p-4 border shadow-md rounded-lg mb-4 flex flex-col gap-2">
            <h3>Items</h3>
            {data?.stockTransfer?.items?.edges.map((item: any, index: number) => (
                <div key={index} className='border p-2 mt-2 rounded-md'>
                    <div><strong>Variant Name: </strong>{item?.node?.variant?.name}</div>
                    <div><strong>Quantity: </strong>{item?.node?.quantity}</div>
                    <div><strong>Received Quantity: </strong>{item?.node?.receivedQuantity}</div>
                    <div><strong>Rejected Quantity: </strong>{item?.node?.rejectedQuantity}</div>
                </div>
            ))}
        </div>

        {openEdit && <StackTransferForm id={instance} isOpen={openEdit} onClose={()=>setOpenEdit(!openEdit)} refresh={refetch}/>}  
        {openReceiveInventory && <ReceiveTransfer transferId={instance} isOpen={openReceiveInventory} onClose={()=> setOpenReceiveInventory(false)} refresh={refresh} />}
        
    </NxtbnDrawer>
  )
}

export default StockTransferDetailsView